import { Permission } from '@cims-online/shared'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import {
  CASSubtype,
  useSubtypesTableContext,
} from '../../../../SubtypesTableContext'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleEditNotification } from 'hooks/notificationHandler'
import { useEditCasSubtypeMutation } from 'schema'
import { CreateEditFormItemsValues } from '../../components/CreateEditFormItems/types'
import { CreateEditFormItems } from '../../components/CreateEditFormItems'

export function useEditOptions(): EditRowActionOptions<
  CASSubtype,
  CreateEditFormItemsValues
> {
  const { refetch } = useSubtypesTableContext()
  const [edit] = useEditCasSubtypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editCASSubtype: {
        subtype: { name },
      },
    }) => simpleEditNotification(name),
  })
  return {
    permission: Permission.EditCASSubtype,
    modal: {
      type: 'simple',
      recordName: 'name',
      body: <CreateEditFormItems />,
      initialValues: ({ name, description }) => ({ name, description }),
      onOk: async ({ id, ...subtype }, { name, description }) => {
        if (subtype.name !== name || subtype.description !== description) {
          await edit({
            variables: { editCASSubtypeInput: { id, name, description } },
          })
          refetch()
        }
      },
    },
  }
}
